import { FC } from "react";
import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import DiscountCodeForm from "./partials/DiscountCodeForm";
import { useDiscountCodeCreate } from "./hooks";

const DiscountCodeCreate: FC = () => {
  const { form } = useDiscountCodeCreate();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Create new Discount Code" />
        </Typography.Title>
      </Header>
      <Space />
      <DiscountCodeForm {...form} />
    </>
  );
};

export default DiscountCodeCreate;
